module.exports = __webpack_public_path__ + "img/dashboard-bg2.fe8d3919.jpg";